export default "/images/vendor/flag-icons/flags/4x3/bg.svg?9c87ba43360f54e47b2f4deb30fa4bf1";